import graphAxios from "../utils/graph-axios";
import { getFbAccessToken } from "../utils/helpers";

const getBMAds = ({ bmID }) => {
  const fbAccessToken = getFbAccessToken();
  return graphAxios.get(
    `/${bmID}/owned_ad_accounts?fields=account_id,account_status,age,attribution_spec,balance,amount_spent,timezone_id,timezone_name,timezone_offset_hours_utc,owner,currency,created_time&limit=200`,
    {
      params: {
        access_token: fbAccessToken,
      },
    },
  );
};

const getPersonalAds = () => {
  const fbAccessToken = getFbAccessToken();

  return graphAxios.get(
    `/me?fields=personal_ad_accounts.limit(200){account_id,account_status,age,attribution_spec,balance,amount_spent,timezone_id,timezone_name,timezone_offset_hours_utc,owner,currency,created_time}`,
    {
      params: {
        access_token: fbAccessToken,
      },
    },
  );
};

const getAdAccount = () => {
  const fbAccessToken = getFbAccessToken();

  return graphAxios.get(
    `/me?fields=adaccounts.limit(10){account_id,name,account_status,age,attribution_spec,balance,amount_spent,timezone_id,timezone_name,timezone_offset_hours_utc,owner,currency,created_time}`,
    {
      params: {
        access_token: fbAccessToken,
      },
    },
  );
};

const getAdAccountByLink = (link) => {
  return graphAxios.get(link);
};

const getById = ({ id }) => {
  const fbAccessToken = getFbAccessToken();

  return graphAxios.get(`/${id}`, {
    params: {
      access_token: fbAccessToken,
      fields: ["name", "id"].join(","),
    },
  });
};

const AdsAPI = {
  getBMAds,
  getPersonalAds,
  getAdAccount,
  getAdAccountByLink,
  getById,
};
export default AdsAPI;
